import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';
import { FastField } from 'formik';

import SignatureField from '../SignatureField';


const SignatureRenderer = ({ large, signatures }) => {
  const validate = useCallback((value) => !value, []);

  return signatures && (
    <ol>
      {map((signature) => (
        <li key={signature.number}>
          <FastField
            name={`signatures[${signature.number - 1}]`}
            component={SignatureField}
            large={large}
            signature={signature}
            validate={validate}
          />
        </li>
      ), signatures)}
    </ol>
  );
};

SignatureRenderer.propTypes = {
  large: PropTypes.bool,
  signatures: PropTypes.arrayOf(PropTypes.shape({
    number: PropTypes.number.isRequired,
    position: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }),
  })),
};

SignatureRenderer.defaultProps = {
  large: false,
  signatures: null,
};

export default SignatureRenderer;
